// Create a new component: src/components/MainSessionList.js
import React from 'react';
import { useDrop } from 'react-dnd';
import { ItemTypes } from '../constants/appConstants';

const MainSessionList = ({ children, onMoveSession, theme }) => {
  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: ItemTypes.CHAT_SESSION,
    drop: (item) => onMoveSession(item.sessionId, null),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop()
    })
  }));

  return (
    <div
      ref={drop}
      style={{
        backgroundColor: isOver && canDrop ? theme.palette.action.hover : 'transparent',
        transition: 'background-color 0.3s',
        borderRadius: '4px',
        padding: isOver && canDrop ? '4px' : 1,
        margin: isOver && canDrop ? '-4px' : 1,
      }}
    >
      {isOver && canDrop && (
        <div
          style={{
            height: '2px',
            backgroundColor: theme.palette.primary.main,
            marginBottom: '8px'
          }}
        />
      )}
      {children}
    </div>
  );
};

export default MainSessionList;